
export type GetUserStats401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
